<template>
  <div :style="styles.base" @click="handleClickEvent()">
    <ceiba-payment
      :payInfoFlow="currentPaymentConfig.payInfoFlowId"
      :sellChannel="sellChannel"
      :spInfo="spInfo"
      :superCoupons="superCouponsInfo"
      :inviteCode="inviteCode"
      :isBlockOrderFailAlert="!!currentPaymentConfig.payFailMsg"
      :isUseRoleLimit="configurationData.forceRole"
      :sku="sku"
      @pay-success="handlePaySuccess"
      @pay-close="handlePayClose"
      @reach-limit="handleReachLimit"
      @get-pay-info="handleGetPayInfo"
      @midas-buy="handleMidasBuy"
      @query-unpaid-orders="handleQueryOrders"
      @cancel-order="handleCancelOrder"
      ref="paymentRef"
    >
    </ceiba-payment>
    <c-button ref="button" :style="computedStyle" v-bind="$props"></c-button>
    <!--订单二次确认弹框-->
    <c-base-dialog
      v-model="confirmOrder"
      :option="confirmOrderDialogOption"
      @confirm="confirmOrder = false"
      @close="confirmOrder = false"
      v-transfer-dom
    >
      <template slot="body">
        <div>
          <div
            :class="getCss('msg-item')"
            v-for="(option, index) of confirmOrderDialogContent"
            :key="index"
          >
            <span :class="getCss('msg-item-label')"
            >{{ option.label }}:</span>
            <span :class="getCss('msg-item-content')"
                  v-html="confirmOrderOption(option.content)"></span>
          </div>
        </div>
      </template>
      <template slot="fotter">
        <div>
          <button
            :style="confirmOrderButtonStyle"
            class="ceiba-base-dialog-ft-button"
            @click="payOrderViaSecondConfirm()"
          >{{ confirmOrderButtonText }}
          </button>
        </div>
      </template>
    </c-base-dialog>
    <!--自定义购买数量弹窗-->
    <c-base-dialog
      v-model="showInputBuyQuantity"
      :option="inputBuyGoodsNumPopOption"
      @close="closeInputBuyQuantityPop"
      @confirm="closeInputBuyQuantityPop"
      v-transfer-dom>
      <template slot="body">
        <div>
          <div :class="getCss('goods-img-area')">
            <img
              v-if="skuGoodsInfo.skuIcon"
              :src="skuGoodsInfo.skuIcon" alt="">
          </div>
          <div :class="getCss('input-line')">
            <span :style="inputLabelStyle"
                  :class="getCss('input-label')">{{inputBuyQuantityLabelTitle}}</span>
            <button
              @click="add(-1)"
              :style="inputReduceIconStyle"
              :class="getCss('input-button')"></button>
            <input :style="inputTextStyle"
                   :value="quantity"
                   @input="handleInputQuantity"
                   @change="handleInputQuantity"
                   :class="getCss('input')" type="number"/>
            <button :style="inputAddIconStyle"
                    @click="add(1)"
                    :class="getCss('input-button')"></button>
          </div>
          <div :class="getCss('submit-btn')"
               @click="payOrderViaInputGoodsQuantity"
               :style="submitBugIconStyle">
          </div>
          <div :class="getCss('submit-buy-quantity-error')">
            <span v-if="showInputBuyQuantityLimitError" :style="isInputBuyQuantityLimitErrorTextStyle">
                  {{inputBuyQuantityErrorMsg}}
            </span>
          </div>
        </div>
      </template>
    </c-base-dialog>
    <!--优惠券弹窗-->
    <c-base-dialog
      v-model="showCouponPop"
      :option="couponPopOption"
      @close="showCouponPop = false"
      @confirm="payOrderViaCheckedCoupon"
      v-transfer-dom>
      <template slot="body">
        <div>
          <div :class="getCss('coupon-area')" v-if="couponList.length > 0">
            <ul :class="getCss('coupon-area-ul')">
              <li
                v-for="(item, index) in couponList"
                :key="`coupon${index}`"
                :class="getCss('coupon-area-li')"
              >
                <div :class="getCss('coupon-item')" :style="couponItemStyle">
                  <div :class="getCss('coupon-item-left')">
                    <p :class="getCss('coupon-item-amt')" :style="couponItemAmtStyle">
                      <span :style="couponItemAmtSymbolStyle">￥</span>
                      {{ item.amt/100 }}
                    </p>
                    <p :style="couponItemLeastPriceStyle">{{`满${ item.least_price / 100 }可用`}}</p>
                  </div>
                  <div :class="getCss('coupon-item-middle')">
                    <p :class="getCss('coupon-item-title')" :style="couponItemTitleStyle">{{ item.title }}</p>
                    <p :class="getCss('coupon-item-time-limit')" :style="couponItemTimeLimitStyle">
                      {{ `${timestampToDate(item.start_time)}-${timestampToDate(item.end_time)}` }}
                    </p>
                  </div>
                  <div :class="getCss('coupon-item-right')">
                    <div
                      :class="getCss('coupon-item-check')"
                      :style="couponItemCheckStyle"
                      @click="checkedCoupon(item.batch_id)"
                    >
                      <div
                        :class="getCss(batchId === item.batch_id
                          ? 'coupon-item-checked'
                          : 'coupon-item-no-checked'
                        )"
                        :style="couponItemCheckedStyle"
                      ></div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div :class="getCss('no-coupon-area')" v-else>
            <img :class="getCss('no-coupon-img')"
                 src="https://game.gtimg.cn/images/js/img/tgclub/emptyImageStatus.png" alt="">
            <p :class="getCss('no-coupon-text')">暂无可用优惠券</p>
          </div>
        </div>
      </template>
    </c-base-dialog>
  </div>
</template>
<script>
import { componentBaseMixin, common } from '@tencent/ceiba-base-components';
import CButton from '@tencent/ceiba-act-public-button';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';

const forbiddenUserPaymentWithCouponRemark = 'noCoupons'; // 禁止支付使用优惠券标志
const couponAvailableUseStatus = 1; // 券可用状态
const couponAvailableUseSubStatus = 0; // 券可用状态

export default {
  name: 'CPublicPayButtonSku',
  components: {
    [CButton.name]: CButton,
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'public-pay-button-sku',
      // 单账号已使用量
      accountUsedLimit: {
        day: 0,
        week: 0,
        month: 0,
        total: 0,
      },
      // 已使用的总量
      usedLimit: {
        day: 0,
        week: 0,
        month: 0,
        total: 0,
      },
      confirmOrder: false, // 是否显示订单二次确认弹框
      batchId: '', // 当前选中的优惠券
      couponList: [], // 可用优惠券列表
      paymentButtonStatus: 1, // 默认支付模式
      quantity: 1, // 自定义购买数量
      showInputBuyQuantity: false, // 打开显示输入购买数量
      showInputBuyQuantityLimitError: false, // 自定义数量购买显示错误
      showCouponPop: false, // 优惠券弹窗
      unpaindOrderList: [], // 未支付订单列表
    };
  },
  computed: {
    /**
     * 当前支付模式配置信息
     * @returns {*}
     */
    currentPaymentConfig() {
      const paymentConfig = this.getPaymentConfigByStatus(this.paymentButtonStatus);
      console.log('CPublicPayButtonSku this.currentPaymentConfig and status value =', this.paymentButtonStatus);
      console.log('CPublicPayButtonSku this.currentPaymentConfig =', paymentConfig);
      return paymentConfig;
    },
    // 当前渠道sku商品信息
    skuGoodsInfo() {
      const goodsItem = this.skuGoodsList().find(item => item.sellChannel === this.sellChannel
        && item.sellChannelAvailable === true);
      console.log('CPublicPayButtonSku sku goods info = ', goodsItem);
      return goodsItem ?? {};
    },
    /**
     * 当前渠道下单sku信息
     * @returns {{quantity: default.computed.quantity, goods_list: (*|string), zoneIdType: number}}
     */
    sku() {
      const { goodsId = '', zoneIdType = 0 } = this.skuGoodsInfo;
      const { quantity } = this;
      return {
        quantity,
        goods_list: goodsId,
        zoneIdType,
      };
    },
    /**
     * 单笔购买的最大数量
     * @returns {number}
     */
    maxGoodsNum() {
      const { singleNumber } = this.skuGoodsInfo;
      // 根据礼包限量，取单笔购买最大购买数量，0表示不限量
      // 取剩余购买次数（剩余购买次数有判断礼包限量）
      // 不能超过单笔购买的最大数量
      return this.remnantPayTimes < singleNumber ? this.remnantPayTimes : singleNumber;
    },
    /**
     * 邀请码
     * @returns {string|string}
     */
    inviteCode() {
      return common.tool.getQueryparams('inviteCode') || '';
    },
    sellChannel() {
      const { sellChannel = 'vip' } = this.configurationData;
      if (this.$isInEditor) return  sellChannel;
      let { specifiedSellChannel = [] } = this.configurationData;
      console.log('CPublicPayButtonSku parse before channel 区分销售渠道=  ', specifiedSellChannel);
      if (!(specifiedSellChannel instanceof Array)) {
        specifiedSellChannel = [];
      }
      if (specifiedSellChannel.length === 0) {
        console.warn(
          'CPublicPayButtonSku call getSellChannel and specifiedSellChannel is empty and access default sellChannel = ',
          sellChannel,
        );
        return  sellChannel;
      }
      try {
        specifiedSellChannel = specifiedSellChannel.map((item) => {
          if (typeof item === 'string' && item.length > 0) {
            return JSON.parse(item);
          }
          return item;
        });
      } catch (e) {
        console.error(
          'CPublicPayButtonSku parse specifiedSellChannel  has error and access default sellChannel = ',
          sellChannel,
        );
        return  sellChannel;
      }
      const hitChannel = typeof common.tool.getRuleValue === 'function'
        ? common.tool.getRuleValue(this, specifiedSellChannel) : '';
      console.log('CPublicPayButtonSku call getSellChannel and return hitChannel  2 = ', hitChannel);
      if  (typeof  hitChannel !== 'string' || hitChannel.length ===  0) {
        console.warn(
          'CPublicPayButtonSku call getSellChannel and not match and access default sellChannel = ',
          sellChannel,
        );
        return sellChannel;
      }
      return hitChannel;
    },
    inputLabelStyle() {
      const { fontFamily, textColor, textFontSize } = this.inputBuyGoodsStyleConfig;
      return {
        fontFamily,
        color: textColor,
        fontSize: textFontSize,
      };
    },
    inputTextStyle() {
      const { fontFamily, inputBgColor, inputNumColor, inputNumFontSize } = this.inputBuyGoodsStyleConfig;
      return {
        fontFamily,
        backgroundColor: inputBgColor,
        color: inputNumColor,
        fontSize: inputNumFontSize,
      };
    },
    inputAddIconStyle() {
      const { addNumIcon } = this.inputBuyGoodsStyleConfig;
      return {
        backgroundImage: `url(${addNumIcon})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%',
      };
    },
    inputReduceIconStyle() {
      const { reduceIcon } = this.inputBuyGoodsStyleConfig;
      return {
        backgroundImage: `url(${reduceIcon})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%',
      };
    },
    submitBugIconStyle() {
      const { submitBugIconWidth, submitBugIconHeight, submitBugIcon } = this.inputBuyGoodsStyleConfig;
      return {
        width: submitBugIconWidth,
        height: submitBugIconHeight,
        backgroundImage: `url(${submitBugIcon})`,
      };
    },
    /**
     * 输入自定义模式单次购买超过限购的文案，并且能替换显示的限制数量
     * @returns {string}
     */
    inputBuyQuantityErrorMsg() {
      const { inputBuyQuantityErrorText = '' } = this.configurationData;
      const { maxGoodsNum } = this;
      if  (!inputBuyQuantityErrorText) {
        return '';
      }
      return inputBuyQuantityErrorText.replace('{{num}}', maxGoodsNum);
    },
    /**
     * 单次购买超过限购的文案的内联样式
     * @returns {{fontFamily: *, color: string, fontSize: string}}
     */
    isInputBuyQuantityLimitErrorTextStyle() {
      const { textBuyLimitErrorColor = '#da123f', textBuyLimitFontSize = '0.24rem', fontFamily } = this.inputBuyGoodsStyleConfig;
      return {
        color: textBuyLimitErrorColor,
        fontSize: textBuyLimitFontSize,
        fontFamily,
      };
    },
    inputBuyQuantityLabelTitle() {
      const { inputBuyQuantityLabelTitle = '购买数量' } = this.configurationData;
      return inputBuyQuantityLabelTitle;
    },
    inputBuyGoodsStyleConfig() {
      return this.styles.inputBuyGoodsNumPopConfig ?? {};
    },
    // 输入购买数量
    inputBuyGoodsNumPopOption() {
      const {
        bgImage = '', popWidth = '676px',
        popHeight = '548px',
      } = this.inputBuyGoodsStyleConfig;
      return Object.assign({}, this.dialogConfig, {
        fotter: true,
        close: true,
        header: false,
        cancel: false,
        confirm: false,
        width: popWidth,
        height: popHeight,
        dialogStyle:
          {
            backgroundImage: `url(${bgImage})`,
          }
        ,
      });
    },
    // 是否自定义输入购买数量
    isInputBuyQuantity() {
      const { isInputBuyQuantity = false } = this.configurationData;
      return isInputBuyQuantity;
    },
    confirmOrderDialogContent() {
      const { paymentButtonStatus } = this;
      return this.configurationData[`confirmOrderDialogContentStatus_${paymentButtonStatus}`] || [];
    },
    // 单账号周期内剩余购买次数（限量）
    remnantPayTimes() {
      const { limit = {}, singleNumber } = this.skuGoodsInfo;
      const { account: accountLimit = {} } = limit;
      const { day: dayLimit = 0, week: weekLimit = 0, month: monthLimit = 0, total: totalLimit = 0 } = accountLimit;
      const { day: dayUsedLimit = 0, week: weekUsedLimit = 0,
        month: monthUsedLimit = 0, total: totalUsedLimit = 0 } = this.accountUsedLimit;
      if (dayLimit > 0) {
        return dayLimit - dayUsedLimit;
      }
      if (weekLimit > 0) {
        return weekLimit - weekUsedLimit;
      }
      if (monthLimit > 0) {
        return monthLimit - monthUsedLimit;
      }
      if (totalLimit > 0) {
        return totalLimit - totalUsedLimit;
      }
      // 不限量，返回单笔购买最大次数
      return singleNumber;
    },
    // 剩余总购买次数（限量）
    availableQuantityTimes() {
      const { limit = {} } = this.skuGoodsInfo;
      const { resource: resourceLimit = {} } = limit;
      const { day: dayLimit = 0, week: weekLimit = 0, month: monthLimit = 0, total: totalLimit = 0 } = resourceLimit;
      const { day: dayUsedLimit = 0, week: weekUsedLimit = 0,
        month: monthUsedLimit = 0, total: totalUsedLimit = 0 } = this.usedLimit;
      if (dayLimit > 0) {
        return dayLimit - dayUsedLimit;
      }
      if (weekLimit > 0) {
        return weekLimit - weekUsedLimit;
      }
      if (monthLimit > 0) {
        return monthLimit - monthUsedLimit;
      }
      if (totalLimit > 0) {
        return totalLimit - totalUsedLimit;
      }
      return 1;
    },
    // 限量周期内未支付订单列表
    quaCycleUnpaindOrderList() {
      const { limit = {} } = this.skuGoodsInfo;
      const { account: accountLimit = {} } = limit;
      const { day: dayLimit = 0, week: weekLimit = 0, month: monthLimit = 0, total: totalLimit = 0 } = accountLimit;
      const filterUnpaindOrder = (startTime, endTime) => this.unpaindOrderList.filter(item => item.createAt >= startTime
        && item.createAt < endTime);
      const { currentMonthTime, currentWeekTime, todayTime } = this.getTime();
      if (totalLimit > 0) {
        return this.unpaindOrderList;
      }
      if (monthLimit > 0) {
        const { startTime, endTime } = currentMonthTime();
        return filterUnpaindOrder(startTime, endTime);
      }
      if (weekLimit > 0) {
        const { startTime, endTime } = currentWeekTime();
        return filterUnpaindOrder(startTime, endTime);
      }
      if (dayLimit > 0) {
        const { startTime, endTime } = todayTime();
        return filterUnpaindOrder(startTime, endTime);
      }
      return [];
    },
    /**
     * 限量周期内是否有未支付订单
     * @returns {boolean}
     */
    isHasUnpaindOrder() {
      return this.quaCycleUnpaindOrderList.length > 0;
    },
    // 支付按钮的状态
    // 按钮样式 payBackgroundImage 支付icon
    // 按钮样式 payDoneBackgroundImage 已达上限按钮
    computedStyle() {
      const { payBackgroundImage, payDoneBackgroundImage, notAvailableQuantityBackgroundImage,
      } = this.currentPaymentConfig;
      let backgroundImage = payBackgroundImage;
      // 总限余量为0，显示已售罄按钮
      if (this.availableQuantityTimes <= 0) { // 没有总限
        backgroundImage = notAvailableQuantityBackgroundImage;
      }
      // 单账号余量为0，没有未支付订单，显示已支付按钮
      if (this.remnantPayTimes <= 0 && !this.isHasUnpaindOrder) {
        backgroundImage = payDoneBackgroundImage;
      }
      // 单账号余量为0，有未支付订单，显示未支付按钮
      if (this.remnantPayTimes <= 0 && this.isHasUnpaindOrder) {
        backgroundImage = payBackgroundImage;
      }
      return {
        cursor: 'pointer',
        position: 'static',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundImage: `url(${backgroundImage})`,
      };
    },
    // 二次确认弹框
    confirmOrderDialogOption() {
      return Object.assign({}, this.dialogConfig, {
        header: this.configurationData.confirmOrderDialogTitle || '订单确认',
        footer: false,
        height: this.deviceMode === 'pc' ? '660px' : '6.6rem',
        width: this.deviceMode === 'pc' ? '820px' : '7.2rem',
        dialogStyle: Object.assign({ color: '#000000' }, this.dialogConfig?.dialogStyle || {}),
      });
    },
    // 二次确认弹框下单样式
    confirmOrderButtonStyle() {
      if (this.dialogConfig?.confirmStyle?.backgroundImage) {
        return {
          width: '2.2rem',
          display: 'block',
          height: '0.65rem',
          backgroundImage: this.dialogConfig?.confirmStyle?.backgroundImage,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          margin: '0 0',
        };
      }
      return {
        width: '2.2rem',
        display: 'block',
        height: '0.65rem',
        backgroundColor: '#3b3a3a',
        color: '#fff',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        margin: '0 0',
      };
    },
    confirmOrderButtonText() {
      return this.dialogConfig?.confirmStyle?.backgroundImage ? '' : '确认';
    },
    // 下单支付时可用优惠券的列表
    spInfo() {
      const spInfoText = this.superCouponsInfo === forbiddenUserPaymentWithCouponRemark ? '' : this.superCouponsInfo;
      console.log('CPublicPayButtonSku computer 可用优惠券列表 spInfo res  =', spInfoText);
      return spInfoText;
    },
    // 支付是否使用优惠券
    // noCoupons 表示禁止支付选用优惠券
    // “${codeId},${batchId}”  //  这个是选中一张默认优惠券
    superCouponsInfo() {
      if (!this.batchId) {
        console.log('CPublicPayButtonSku computer superCouponsInfo res = empty', forbiddenUserPaymentWithCouponRemark);
        return forbiddenUserPaymentWithCouponRemark;
      }
      if (this.couponList.length === 0) return forbiddenUserPaymentWithCouponRemark;
      const { batchId } = this;
      const item = this.couponList.find(item => item.batch_id === batchId);
      const res = item ? `${item.code_id},${item.batch_id}` : forbiddenUserPaymentWithCouponRemark;
      console.log('CPublicPayButtonSku computer superCouponsInfo res =', res);
      return res;
    },
    // 优惠券弹窗样式
    couponPopOption() {
      const { couponPopConfirmButtonText } = this.configurationData;
      const { couponPopStyle = {} } = this.styles;
      const { backgroundColor,
        color,
        confirmButtonBackgroundColor,
        confirmButtonColor,
      } = couponPopStyle;
      return  Object.assign({}, this.dialogConfig, {
        header: '选择优惠券',
        fotter: true,
        close: true,
        confirm: couponPopConfirmButtonText || '确定',
        positionType: 'bottom',
        closeLocation: 'top-right-isBottom',
        closeStyle: {},
        confirmStyle: Object.assign({}, {}, {
          backgroundColor: confirmButtonBackgroundColor || '#d7b386',
          borderRadius: '0.16rem',
          color: confirmButtonColor || '#fff',
          fontSize: '.32rem',
          width: '6.86rem',
          height: '0.96rem',
          lineHeight: '0.96rem',
          position: 'absolute',
          bottom: 0,
        }),
        height: this.deviceMode === 'pc' ? '360px' :  '6.85rem',
        width: this.deviceMode === 'pc' ? '750px' : '7.5rem',
        dialogStyle: Object.assign({}, {}, {
          color: color || '#242424',
          padding: 0,
          backgroundColor: backgroundColor || '#ffffff',
        }),
      });
    },
    couponItemStyle() {
      const { couponPopStyle = {} } = this.styles;
      const { couponBackgroundImage = '//game.gtimg.cn/images/tgclub/act/a20211227bigMall/coupon_bg.png' } = couponPopStyle;
      return {
        backgroundImage: `url(${couponBackgroundImage})`,
        backgroundSize: '100%',
      };
    },
    couponItemAmtStyle() {
      const { couponPopStyle = {} } = this.styles;
      const {
        amtColor: color = '#b68950',
        amtFontFamily: fontFamily = 'D-DINExp-Bold',
        amtFontSize: fontSize = '.48rem',
      } = couponPopStyle;
      return {
        color,
        fontFamily,
        fontSize,
      };
    },
    couponItemAmtSymbolStyle() {
      const { couponPopStyle = {} } = this.styles;
      const {
        amtFontSize: fontSize = '.28rem',
      } = couponPopStyle;
      return {
        fontSize,
      };
    },
    couponItemLeastPriceStyle() {
      const { couponPopStyle = {} } = this.styles;
      const {
        LeastPriceFontSize: fontSize = '.22rem',
        LeastPriceColor: color = '#262626',
      } = couponPopStyle;
      return {
        fontSize,
        color,
      };
    },
    couponItemTitleStyle() {
      const { couponPopStyle = {} } = this.styles;
      const {
        couponTitleFontSize: fontSize = '.28rem',
        couponTitleColor: color = '#000',
      } = couponPopStyle;
      return {
        color,
        fontSize,
      };
    },
    couponItemTimeLimitStyle() {
      const { couponPopStyle = {} } = this.styles;
      const {
        couponTimeLimitFontSize: fontSize = '.22rem',
        couponTimeLimitColor: color = '#8e8e93',
      } = couponPopStyle;
      return {
        color,
        fontSize,
      };
    },
    couponItemCheckStyle() {
      const { couponPopStyle = {} } = this.styles;
      const {
        couponCheckBorderColor: borderColor = '#d87d0b',
      } = couponPopStyle;
      return {
        border: `0.02rem solid ${borderColor}`,
      };
    },
    couponItemCheckedStyle() {
      const { couponPopStyle = {} } = this.styles;
      const {
        couponCheckedBackgroundImage: backgroundImage = '//game.gtimg.cn/images/tgclub/act/a20211227bigMall/coupon_chosed.png',
      } = couponPopStyle;
      return {
        backgroundImage: `url(${backgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%',
      };
    },
    accType() {
      return this.isLogin ? this.userInfo.acctype : '';
    },
    roleName() {
      return this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.role_name || '') : '';
    },
    partitionName() {
      return this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.partition_name || '') : '';
    },
    nickName() {
      return this.isLogin ? this.userInfo.nickName : '';
    },
  },
  async mounted() {
    console.log('CPublicPayButtonSku configurationData=', this.configurationData);
    await this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$isInEditor) return;
      const { forceRole } = this.configurationData;
      this.$refs.button.setClickHandler(this.payOrder, {
        forceLogin: true,
        forceApp: false,
        forceRole,
      });
      if (forceRole) {
        this.$onRoleReady(() => {
          // 查询剩余限量
          this.queryUsedLimit();
          //  查询单账号剩余限量
          this.queryAccountUsedLimit();
          // 查询未支付订单
          this.getUnpaidOrderList();
        });
      } else {
        this.$onLogined(() => {
          // 查询剩余限量
          this.queryUsedLimit();
          //  查询单账号剩余限量
          this.queryAccountUsedLimit();
          // 查询未支付订单
          this.getUnpaidOrderList();
        });
      };
    },
    // 获取sku商品列表
    skuGoodsList() {
      const { skuConfig = { goodsInfo: {} } } = this.configurationData;
      const goodsList =  Object.entries(skuConfig.goodsInfo).map(([, goodsInfo]) => {
        const { metadata = {}, attached_info: attacheInfo = {}, shipment_info: shipmentInfo = {},
          price_info: priceInfo = [], payment_info: paymentInfo = {}, sellChannelAvailable = true } = goodsInfo ;
        const { goods_id: goodsId, gid, sell_channel: sellChannel  } = metadata;
        const { sku_icon: skuIcon, sku_id: skuId, attached = {} } = attacheInfo;
        const { singleNumber = 1 } = attached;
        const { rid: resourceId, name, limit = {} } = shipmentInfo;
        const { price_configs: priceConfigs = [] } = priceInfo;
        const { midas_buy: midasBuy = {} } = paymentInfo;
        const { zoneid_type: zoneIdType = 0 } = midasBuy;
        const { price = 0, list_price: listPrice = 0 } = priceConfigs.find((item)  =>  {
          const   { currency_type: currencyType = 0 } = item;
          return currencyType === 0;
        }) || {};
        return {
          skuId,
          gid,
          sellChannel,
          goodsId,
          name,
          skuIcon,
          resourceId,
          price,
          listPrice,
          sellChannelAvailable,
          zoneIdType,
          limit,
          singleNumber,
        };
      });
      console.log('CPublicPayButtonSku sku goods list = ', goodsList);
      return goodsList ?? [];
    },
    closeInputBuyQuantityPop() {
      this.showInputBuyQuantityLimitError = false;
      this.showInputBuyQuantity = false;
    },
    /**
     * 购买数量+1,并且触发输入购买超过单次购买限量的状态
     * @param step
     */
    add(step) {
      const num = this.quantity + step;
      if (num > this.maxGoodsNum) {
        this.quantity = this.maxGoodsNum;
        this.showInputBuyQuantityLimitError = true;
      } else if (num <= 0) {
        this.quantity = 1;
        this.showInputBuyQuantityLimitError = false;
      } else {
        this.quantity = num;
      }
      console.log('CPublicPayButtonSku this.quantity = ', this.quantity);
    },
    handleInputQuantity(e) {
      const num = parseInt(e.target.value, 10);
      console.log('CPublicPayButtonSku handleInputPrice num =', num, 'maxGoodsNum =', this.maxGoodsNum);
      if (num > this.maxGoodsNum) {
        this.quantity = this.maxGoodsNum;
        e.target.value = this.maxGoodsNum;
        this.showInputBuyQuantityLimitError = true;
      } else if (num <= 0) {
        this.quantity = 1;
        e.target.value = 1;
        this.showInputBuyQuantityLimitError = false;
      } else {
        this.quantity = num;
        e.target.value = num;
        this.showInputBuyQuantityLimitError = false;
      }
      console.log('CPublicPayButtonSku this.quantity = ', this.quantity);
    },
    // 获取对应支付状态配置信息，用于扩展多状态的支付模式
    getPaymentConfigByStatus(status) {
      const { paymentInfoConfigList = [] } = this.configurationData;
      const res = paymentInfoConfigList.find(item => parseInt(item.status, 10) === status);
      if (!res) {
        console.error('CPublicPayButtonSku 支付状态信息没有配置 status = ', status);
      }
      return res;
    },
    handleGoodsNumInput() {
      if (this.isInputBuyQuantity) {
        this.quantity = 1;
        this.showInputBuyQuantity = true;
        return true;
      }
      return false;
    },
    /**
     * 选中优惠券
     * @param batchId
     */
    checkedCoupon(batchId) {
      this.batchId = batchId === this.batchId ? '' : batchId;
    },
    /**
     * 支付前校验
     * @returns {Promise<boolean>}
     */
    async beforePayOrderCheck() {
      const {
        notAvailableQuantityMsg = '已售罄',
        notRemnantPayTimesMsg = '已购买',
      } = this.currentPaymentConfig;

      // 查询未支付订单
      await this.getUnpaidOrderList();
      // 查询单账号剩余限量
      await this.queryAccountUsedLimit();
      // 没有单账号余量，并且没有未支付订单
      if (this.remnantPayTimes <= 0 && !this.isHasUnpaindOrder) {
        if (!!notRemnantPayTimesMsg) this.$alert({ msg: notRemnantPayTimesMsg });
        return false;
      }
      // 查询剩余总限
      await this.queryUsedLimit();
      // 没有剩余总限，并且没有未支付订单
      if (this.availableQuantityTimes <= 0 && !this.isHasUnpaindOrder) {
        if (!!notAvailableQuantityMsg) this.$alert({ msg: notAvailableQuantityMsg });
        return false;
      }
      return true;
    },
    /**
     * 下单
     * 1、是否开启自定义购买数量
     * 2、选择优惠券
     * 3、是否确认订单
     * @returns {Promise<void>}
     */
    async payOrder() {
      // 支付前校验
      const beforePayOrderCheck = await this.beforePayOrderCheck();
      if (!beforePayOrderCheck) {
        console.warn('CPublicPayButtonSku beforePayOrderCheck before Check not ok ');
        return;
      }
      // 如果单账号余量为0也能下单（有未支付订单，只是不能支付） --取消订单
      if (this.remnantPayTimes > 0) {
        // 是否有自定义输入模式
        if (this.handleGoodsNumInput() === true) {
          console.log('CPublicPayButtonSku 开始自定义输入购买数量模式');
          return;
        }
        // 查询优惠券
        await this.queryCouponList();
        if (this.couponList.length > 0) {
          this.showCouponPop = true;
          console.info('CPublicPayButtonSku payOrder before show coupon pop');
          return;
        }
        // 是否确认订单
        const { isConfirmOrder } = this.configurationData;
        if (isConfirmOrder) {
          this.confirmOrder = true;
          return;
        }
      }
      await this.toOrder();
    },
    // 通过自定义购买数量下单
    async payOrderViaInputGoodsQuantity() {
      if (this.quantity <= 0) {
        this.$alert({ msg: '购买商品数量不能为零' });
        return false;
      }
      if (this.quantity > this.maxGoodsNum) {
        this.$alert({ msg: '单次购买数量超过上限' });
        return false;
      }
      // 查询优惠券
      await this.queryCouponList();
      if (this.couponList.length > 0) {
        this.closeInputBuyQuantityPop();
        this.showCouponPop = true;
        console.info('CPublicPayButtonSku payOrder before show coupon pop');
        return;
      }
      // 是否确认订单
      const { isConfirmOrder } = this.configurationData;
      if (isConfirmOrder) {
        this.closeInputBuyQuantityPop();
        this.confirmOrder = true;
        return;
      }
      this.closeInputBuyQuantityPop();

      await this.toOrder();
    },
    /**
     * 选中优惠券后确认按钮，继续下单
     * @returns {Promise<void>}
     */
    async payOrderViaCheckedCoupon() {
      this.showCouponPop = false;
      const { isConfirmOrder } = this.configurationData;
      if (isConfirmOrder) {
        this.confirmOrder = true;
        return;
      }
      await this.toOrder();
    },
    // 通过订单确认下单
    async payOrderViaSecondConfirm() {
      this.confirmOrder = false;
      await this.toOrder();
    },
    // 支付下单 调用米大师 支付
    async toOrder() {
      if (!this.isLogin) return;
      try {
        await this.$refs.paymentRef.buy();
      } catch (e) {
        console.error('CPublicPayButtonSku payOrder fail, err=', e);
      }
    },
    // 支付限量
    async handleReachLimit() {
      console.log('CPublicPayButtonSku ====支付限量====');
    },
    // 支付失败
    // 支付失败
    async handlePayClose() {
      console.log('CPublicPayButtonSku ====支付失败====');
      // 查询未支付订单
      await this.getUnpaidOrderList();
      // 查询剩余限量
      this.queryUsedLimit();
      //  查询单账号剩余限量
      this.queryAccountUsedLimit();
    },
    // 支付成功回调
    handlePaySuccess(midasInfo) {
      console.log('CPublicPayButtonSku handlePaySuccess midasInfo', midasInfo);
      const { paySuccessMsg } = this.currentPaymentConfig;

      this.refreshQua(); // 刷新礼包
      this.queryUsedLimit();// 查询剩余总限量
      this.queryAccountUsedLimit(); // 重新查询单账号剩余限量
      // 支付成功自定义提示
      if (paySuccessMsg) {
        this.$alert({ msg: paySuccessMsg.replace('{{partition}}', this.partitionName).replace('{{role}}', this.roleName) });
      }
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'pay_callback',
        eventData: {
          order_id: midasInfo.order_id,
          status: '1',
        },
      });
    },
    // 执行下单逻辑
    handleGetPayInfo({ response }) {
      console.log('CPublicPayButtonSku handleGetPayInfo params', { response });
      const { payFailMsg } = this.currentPaymentConfig;
      const { ret, data } = response;
      const { ret: resRet } = data;
      if ((ret !== 0 || resRet !== 0) && !!payFailMsg) {
        this.$alert({ msg: payFailMsg.replace('{{partition}}', this.partitionName).replace('{{role}}', this.roleName) });
      }
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'pay_makeorder',
        eventData: {
          status: ret === 0 && resRet === 0 ? '1' : '0',
        },
      });
    },
    // 查询未支付的订单
    handleQueryOrders({ response }) {
      console.log('CPublicPayButtonSku handleQueryOrders params', { response });
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'pay_queryorders',
        eventData: {
          status: response.ret === 0 ? '1' : '0',
        },
      });
    },
    // 取消订单
    async handleCancelOrder({ orderId, response }) {
      console.log('CPublicPayButtonSku handleCancelOrder params', { orderId, response });
      // 取消订单后资格回滚有延迟
      this.refreshAccountUsedLimit();
      this.refreshUsedLimit();
      // 查询未支付订单
      await this.getUnpaidOrderList();
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'pay_cancelorder',
        eventData: {
          order_id: orderId,
          status: response.ret === 0 ? '1' : '0',
        },
      });
    },
    // 米大师支付 (用户拉去支付)
    handleMidasBuy(midasInfo) {
      console.log('CPublicPayButtonSku handleMidasBuy midasInfo', midasInfo);
      const { price: amount } = this.skuGoodsInfo;
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'pay',
        eventData: {
          order_id: midasInfo.order_id,
          amount,
        },
      });
    },
    // 查询单账号剩余限量（下单也会扣资格）
    async queryAccountUsedLimit() {
      const { queryAccountUsedLimitFlowId = 0 } = this.currentPaymentConfig;
      if (queryAccountUsedLimitFlowId <= 0) return;
      const { skuId, resourceId } = this.skuGoodsInfo;
      const params = {
        flowId: queryAccountUsedLimitFlowId,
        params: {
          role: this.roleInfo,
          data: JSON.stringify({ skuId, resourceId }),
        },
      };
      const response = await this.flowRequest(params);
      console.log('CPublicPayButtonSku 查询单账号剩余限量 queryAccountUsedLimit response ', response);
      const { ret, msg, data = {} } = response;
      if (ret !== 0) {
        return this.$alert({ msg });
      }
      const { day = 0, week = 0, month = 0, total = 0 } = data;
      this.accountUsedLimit = { day, week, month, total };
    },
    // 取消订单刷新资格
    refreshAccountUsedLimit() {
      const { limit = {} } = this.skuGoodsInfo;
      const { account: accountLimit = {} } = limit;
      const { day: dayLimit = 0, week: weekLimit = 0, month: monthLimit = 0, total: totalLimit = 0 } = accountLimit;
      if (dayLimit > 0) {
        const usedLimit = this.accountUsedLimit.day - 1;
        this.accountUsedLimit.day = usedLimit > 0 ? usedLimit : 0 ;
      }
      if (weekLimit > 0) {
        const usedLimit = this.accountUsedLimit.week - 1;
        this.accountUsedLimit.week = usedLimit > 0 ? usedLimit : 0 ;
      }
      if (monthLimit > 0) {
        const usedLimit = this.accountUsedLimit.month - 1;
        this.accountUsedLimit.month = usedLimit > 0 ? usedLimit : 0 ;
      }
      if (totalLimit > 0) {
        const usedLimit = this.accountUsedLimit.total - 1;
        this.accountUsedLimit.total = usedLimit > 0 ? usedLimit : 0 ;
      }
    },
    // 取消订单刷新资格
    refreshUsedLimit() {
      const { limit = {} } = this.skuGoodsInfo;
      const { resource: resourceLimit = {} } = limit;
      const { day: dayLimit = 0, week: weekLimit = 0, month: monthLimit = 0, total: totalLimit = 0 } = resourceLimit;
      if (dayLimit > 0) {
        const usedLimit = this.usedLimit.day - 1;
        this.usedLimit.day = usedLimit > 0 ? usedLimit : 0 ;
      }
      if (weekLimit > 0) {
        const usedLimit = this.usedLimit.week - 1;
        this.usedLimit.week = usedLimit > 0 ? usedLimit : 0 ;
      }
      if (monthLimit > 0) {
        const usedLimit = this.usedLimit.month - 1;
        this.usedLimit.month = usedLimit > 0 ? usedLimit : 0 ;
      }
      if (totalLimit > 0) {
        const usedLimit = this.usedLimit.total - 1;
        this.usedLimit.total = usedLimit > 0 ? usedLimit : 0 ;
      }
    },
    // 查询剩余总限量（下单也会扣资格）
    async queryUsedLimit() {
      const { queryUsedLimitFlowId = 0 } = this.currentPaymentConfig;
      if (queryUsedLimitFlowId <= 0) return;
      const { skuId, resourceId } = this.skuGoodsInfo;
      const params = {
        flowId: queryUsedLimitFlowId,
        params: {
          role: this.roleInfo,
          data: JSON.stringify({ skuId, resourceId }),
        },
      };
      const response = await this.flowRequest(params);
      console.log('CPublicPayButtonSku 查询剩余总限量 queryUsedLimit response ', response);
      const { ret, msg, data = {} } = response;
      if (ret !== 0) {
        return this.$alert({ msg });
      }
      const { day = 0, week = 0, month = 0, total = 0 } = data;
      this.usedLimit = { day, week, month, total };
    },
    // 订单确认弹框-确认项
    confirmOrderOption(text) {
      const uinTypeName = this.accType === 'wx' ? '【微信账户】' : '【QQ账户】';
      const nickName = `<span class="csu-public-pay-button-msg-item-nick-name">${this.nickName}</span>${uinTypeName}`;
      const { name: goodsName, price: payment } = this.skuGoodsInfo;
      const { quantity, batchId } = this;
      const { amt: couponAmt = 0 } = this.couponList.find(item => item.batch_id === batchId) ?? {};
      return text.replace('{{role}}', this.roleName)
        .replace('{{partition}}', this.partitionName)
        .replace('{{uin}}', nickName)
        .replace('{{goodsName}}', goodsName)
        .replace('{{payment}}', payment / 100 * quantity - couponAmt / 100)
        .replace('{{quantity}}', ` * ${quantity}`)
        .replace('{{couponAmt}}', couponAmt > 0 ? `，已优惠￥${couponAmt / 100}` : '');
    },
    // 查询优惠券列表
    async queryCouponList() {
      const { queryCouponListFlowId } = this.currentPaymentConfig;
      if (queryCouponListFlowId <= 0) return;
      this.couponList = [];
      const params = {
        flowId: queryCouponListFlowId,
        params: {
          role: this.roleInfo,
        },
      };
      const response = await this.flowRequest(params);
      console.log('CPublicPayButtonSku queryCouponList response:', response);
      const { ret, msg, data = {} } = response;
      if (ret !== 0) {
        return this.$alert({ msg });
      }
      const { ret: resRet, msg: resMsg } = data;
      if (resRet !== 0) {
        return this.$alert({ msg: resMsg });
      }
      let couponFilterList = [];
      const { data: resData } = data;
      if (resData && resData.length > 0) {
        couponFilterList = resData;
      }
      couponFilterList = couponFilterList.filter(item => this.checkCouponIsStart(item));
      console.log('CPublicPayButtonSku queryCouponList couponList filter coupon status in couponFilterList = ', couponFilterList);
      couponFilterList = this.filterCouponLeastPrice(couponFilterList);
      console.log('CPublicPayButtonSku queryCouponList couponList filter coupon least price in couponFilterList = ', couponFilterList);
      couponFilterList = this.sortCouponList(couponFilterList);
      console.log('CPublicPayButtonSku queryCouponList couponList sort in couponFilterList = ', couponFilterList);
      this.couponList = couponFilterList;
      console.log('CPublicPayButtonSku queryCouponList final couponList', this.couponList);
    },
    // 优惠券排序
    sortCouponList(couponFilterList) {
      if (couponFilterList.length <= 1) {
        return couponFilterList;
      }
      couponFilterList.sort((a, b) => {
        if (a.amt !== b.amt) {
          return b.amt - a.amt;
        }
        return a.start_time - b.start_time;
      });
      return couponFilterList;
    },
    // 测试优惠券是否可以使用
    // status  = 1  && sub_status === 0   可使用
    checkCouponIsStart(couponItem) {
      const { status = 1, sub_status: subStatus = 0 } = couponItem;
      console.log('CPublicPayButtonSku checkCouponIsStart status = ', status, 'sub_status = ', subStatus);
      if (status === couponAvailableUseStatus && subStatus === couponAvailableUseSubStatus) {
        console.log('CPublicPayButtonSku checkCouponIsStart res = ', '优惠券可用', couponItem);
        return true;
      }
      console.log('CPublicPayButtonSku checkCouponIsStart res = ', '不匹配可用状态', couponItem);
      return false;
    },
    /**
     * 过滤优惠券门槛
     * @param couponFilterList
     * @returns {*[]}
     */
    filterCouponLeastPrice(couponFilterList = []) {
      if (couponFilterList.length <= 0) return couponFilterList;
      const { price } = this.skuGoodsInfo;
      const { quantity } = this;
      return couponFilterList.filter(item => item.least_price <= price * quantity);
    },
    timestampToDate(timestamp) {
      const date = new Date(timestamp * 1000);
      const Y = date.getFullYear();
      const M = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
      const D = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
      // const h = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
      // const m = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
      // const s = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
      return `${Y}.${M}.${D}`;
    },
    /**
     * 查询未支付订单列表
     * @returns {Promise<void>}
     */
    async getUnpaidOrderList() {
      const { forceRole: isUseRoleLimit } = this.configurationData;
      const postData = {
        business: 'act',
        sell_scene: `ceiba_act_${this.$actInfo.activity_id}`,
        page_size: 100,
        page_index: 1,
        sell_channel: this.sellChannel,
        role: {},
      };
      if (isUseRoleLimit) {
        postData.role = this.roleInfo;
      }
      try {
        const response = await this.$requestInstance.post('/action/api/common/v2/centralQueryOrders', postData);
        console.info('CPublicPayButtonSku unpaind order list', response);
        if (response.ret) {
          console.warn('CPublicPayButtonSku 拉取未支付订单列表失败', response.msg);
          return;
        }
        const tempOrderList = [];
        response.data?.infoList?.forEach((order) => {
          tempOrderList.push({
            orderId: order.order_id,
            createAt: new Date(order.created_at).getTime(),
            price: order.payment_result?.total_price,
            goodsName: order.attached_info?.sku_name,
            skuId: order.attached_info?.sku_id,
          });
        });
        const { skuId } = this.skuGoodsInfo;
        this.unpaindOrderList = tempOrderList.filter(item => item.skuId === skuId);
      } catch (error) {
        console.error('CPublicPayButtonSku 拉取未支付订单列表失败', error);
      }
    },
    // 获取起止时间
    getTime() {
      // 当前服务器时间
      const currentDate = common.tool.getSeverDateTime();
      // 今天
      const todayTime = () => {
        const startTime = new Date(currentDate).setHours(0, 0, 0);
        const endTime = new Date(currentDate).setHours(23, 59, 59);
        return { startTime, endTime };
      };
      // 本周
      const currentWeekTime = () => {
        const nowTime = currentDate.getTime();
        const weekDay = currentDate.getDay();
        const millisecond = 1000 * 60 * 60 * 24;
        const startTime = new Date(nowTime - (weekDay - 1) * millisecond).setHours(0, 0, 0);
        const endTime = new Date(nowTime + (7 - weekDay) * millisecond).setHours(23, 59, 59);
        return { startTime, endTime };
      };
      // 本月
      const currentMonthTime = () => {
        const nowYear = currentDate.getFullYear();
        const nowMonth = currentDate.getMonth();
        const startTime = new Date(nowYear, nowMonth, 1).setHours(0, 0, 0);
        const endTime = new Date(nowYear, nowMonth + 1, 0).setHours(23, 59, 59);
        return { startTime, endTime };
      };
      return { todayTime, currentWeekTime, currentMonthTime };
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
